import Filter from '@/components/modal-select/filters/Filter.js';

export default class GroupFilter extends Filter {
    constructor(field, label = 'Group') {
        super(field);

        this.type = 'groups';
        this.label = label;

        this.handler = async ({ filterEvent }) => {
            const value = filterEvent.getAttribute('value');

            if (value) {
                this.queryBuilder.filter(field, value);
            } else {
                this.queryBuilder.removeFilter(field);
            }
        };
    }

    clearFilter() {
        this.queryBuilder.removeFilter('groups');
    }
}
